import { render } from "./LKFInput.vue?vue&type=template&id=60190ac9&ts=true"
import script from "./LKFInput.vue?vue&type=script&lang=ts"
export * from "./LKFInput.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__